<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ title | translate}}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true"><img src="assets/images/icon-close-circle.svg" alt="icon-close-circle"></span>
  </button>
</div>

<div class="modal-body d-flex flex-column">
  <div class="message">
    {{content | translate}}
  </div>
  <div class="message">
    <span>{{content2 | translate}}</span> <a href="mailto:{{mailto | translate}}">{{mailto | translate}}</a>
  </div>
</div>

<div class="modal-footer">
  <ng-container>
    <button type="button" class="btn confirm-delete d-flex" (click)="close()">
      <div class="text-uppercase font-weight-bold align-self-center">
        {{btnName | translate}}
      </div>
    </button>
  </ng-container>
</div>
